import { render, staticRenderFns } from "./PersonalRegistration.vue?vue&type=template&id=3028c7c5&scoped=true&"
import script from "./PersonalRegistration.vue?vue&type=script&lang=js&"
export * from "./PersonalRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PersonalRegistration.vue?vue&type=style&index=0&id=3028c7c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3028c7c5",
  null
  
)

export default component.exports